import { makeArticleParagraph } from './internal/makeArticleParagraph';

/**
 * Компонет типогрфики для оформления параграфов в больших текстах
 */
export var ArticleParagraph1 = makeArticleParagraph({
  fontSize: '16px',
  lineHeight: '22px'
});

/**
 * Компонет типогрфики для оформления параграфов в больших текстах
 */
export var ArticleParagraph2 = makeArticleParagraph({
  fontSize: '14px',
  lineHeight: '20px'
});

/**
 * Компонет типогрфики для оформления параграфов в больших текстах
 */
export var ArticleParagraph3 = makeArticleParagraph({
  fontSize: '12px',
  lineHeight: '18px'
});

/**
 * @deprecated возможно вам подойдет Overline
 *
 * Компонет типогрфики для оформления параграфов в больших текстах
 */
export var ArticleParagraph4 = makeArticleParagraph({
  fontSize: '10px',
  lineHeight: '16px'
});